const MuiAccordion = {
  variants: [
    {
      props: { variant: 'gray' },
      style: ({ theme }) => ({
        backgroundColor: theme.palette.gray.A100,
        boxShadow: 'none',
        '&:before': {
          display: 'none',
        },
        '& .MuiAccordionSummary-root': {
          paddingLeft: 0,
          paddingRight: 0,
          minHeight: 'fit-content',
          '&.Mui-expanded': {
            minHeight: 'fit-content',
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
        '& .MuiAccordionSummary-content': {
          marginTop: 0,
          marginBottom: 0,
          '&.Mui-expanded': {
            marginTop: 0,
            marginBottom: 0,
          },
        },
      }),
    },
    {
      props: { variant: 'bordered' },
      style: ({ theme }) => ({
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(2),
        boxShadow: 'none',
        overflow: 'hidden',
        '&:before': {
          display: 'none',
        },
        '& .MuiAccordionSummary-root': {
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(2),
        },
        '& .MuiAccordionSummary-content': {
          alignItems: 'center',
          gap: theme.spacing(1.5),
          marginTop: theme.spacing(1),
          marginBottom: theme.spacing(1),
        },
      }),
    },
  ],
};

export default MuiAccordion;